<!-- <button (click)="openSupport()" pButton icon="fa fa-comment" type="button" class="icon-action"></button>

    <i class="fa fa-th-list"></i>
    <div class="worklist-badge">{{user.worklistSubmitted}}</div> -->


<!-- <a (click)="openSupport()" pTooltip="Support" tooltipPosition="bottom" style="text-decoration:none;">
  <i class="fa fa-comment"> </i>
  <div *ngIf="user.info.orgId == DefaultOrg.OrgId" class="worklist-badge">{{liveRequest.count}}</div>
</a> -->
<div *ngIf="globalDisplay">

  <p-dialog (onHide)="onHideDialog($event)" header="Welcome to Support" [closable]="false" [(visible)]="supportChatDialog.display" [responsive]="true"
            [modal]="false" [style]="DialogStyle40" [resizable]="false">
    <p-header>
      <button *ngIf="user?.info?.orgId == DefaultOrg.OrgId" type="button" pButton icon="fa fa-close" (click)="supportChatDialog.display = false"></button>
    </p-header>
    <section class="connect-prime">
      <div style="margin-top:-12px;">
        <div *ngIf="displayProperty.connected" class="connect-box">
          <div align="left" class="connect-box1">
            <button pButton type="button" class="secondary-action" icon="fa fa-arrow-circle-left" *ngIf="user?.info?.orgId == DefaultOrg.OrgId" (click)="onClickBackToRequestsPage()">
            </button>
            <strong style="font-size: 20px; font-family:monospace"> Support </strong>

          </div>
          <div id="chatbox" #scrollMe [scrollTop]="scrollMe.scrollHeight">
            <ul>
              <li *ngFor='let chat of chatList '>
                <div *ngIf="chat.fromOrgId != user?.info?.orgId" class="left-side">
                  <span *ngIf="chat.type == SupportMessageType.SupportMessage || chat.type == SupportMessageType.SupportAcceptance || chat.type == SupportMessageType.SupportEnd || chat.type == SupportMessageType.SupportReject">
                    <font size="2">
                      <strong> {{chat.fromUserName}} </strong>
                      <font size="1"> {{chat.time}} </font>
                      <br> {{chat.message}}
                    </font>

                  </span>

                  <span *ngIf="chat.type == SupportMessageType.Video">
                    <a (click)="onClickVideoRequest(chat.message)"> Click Here To Accept Video </a>
                  </span>
                </div>
                <div *ngIf="chat.fromOrgId == user?.info?.orgId" class="right-side">
                  <span *ngIf="chat.type == SupportMessageType.SupportMessage || chat.type == SupportMessageType.SupportAcceptance || chat.type == SupportMessageType.SupportEnd || chat.type == SupportMessageType.SupportReject">
                    <font size="2">
                      <strong> {{chat.fromUserName}} </strong>
                      <font size="1"> {{chat.time}} </font>
                      <br> {{chat.message}}
                    </font>

                  </span>

                  <span *ngIf="chat.type == SupportMessageType.Video">
                    <a (click)="onClickVideoRequest(chat.message)"> Click Here To Accept Video </a>
                  </span>
                </div>
              </li>
            </ul>

          </div>


          <textarea pInputTextarea class="message-field" (keyup.enter)="sendMessage()" [(ngModel)]="message" [rows]="3" placeholder="Message Support " style="height:75px!important;width:360px;"></textarea>
          <div align="left" class="bottom-icons">
            <span *ngIf="user?.info?.orgId == DefaultOrg.OrgId">
              <a (click)="onClickVideoCall()">
                <i class="fa fa-video-camera"></i>
              </a>
              <button style="float:right" type="button" class="button-action" pButton (click)="onEndChat()" label="End Chat"></button>

            </span>



            <div class="p-col-12" style="text-align:right;margin-top:15px;">
              <button type="button" class="button-action" pButton (click)="sendMessage()" label="Send"></button>
            </div>
          </div>
        </div>



        <div *ngIf="!displayProperty.connected" class="lds-css ng-scope">
          <div *ngIf="user?.info?.orgId == DefaultOrg.OrgId">
            <div class="connect-box" align="left">
              <h5>Open Chat Sessions</h5>
              <ul align="left" class="support-list">
                <li align="left" *ngFor="let supportRequest of supportRequestList">
                  <p-accordion>
                    <p-accordionTab>
                      <p-header>
                        {{supportRequest.fromUserName}} - {{supportRequest.fromOrgName}}
                        <span *ngIf="supportRequest.status == SupportStatusType.Pending">
                          <i class="fa fa-heartbeat" aria-hidden="true"></i>

                        </span>
                      </p-header>
                      <div class="connect-actionbar">
                        <button [disabled]="supportRequest.status == SupportStatusType.Pending" (click)="onSelectChat(supportRequest)">
                          <i class="fa fa-comment"></i>
                        </button>
                        <button *ngIf="supportRequest.status == SupportStatusType.Pending" pButton (click)="acceptRequest(supportRequest)" class="action-secondary" label="Accept">
                        </button>
                        <button *ngIf="supportRequest.status == SupportStatusType.Pending" pButton (click)="rejectRequest(supportRequest)" class="action-secondary" label="Reject">
                        </button>
                        <button *ngIf="supportRequest.status == SupportStatusType.Terminated" pButton (click)="deleteRequest(supportRequest)" class="action-secondary" label="Delete">
                        </button>


                        <!-- <a>
                    <i class="fa fa-phone"></i>
                  </a>
                  <a href="mailto:">
                    <i class="fa fa-envelope"></i>
                  </a>
                  <a (click)="showGroupInfo(group)">
                    <i class="fa fa-info"></i>
                  </a> -->
                      </div>
                    </p-accordionTab>
                  </p-accordion>
                </li>
              </ul>
            </div>
          </div>
          <div *ngIf="user?.info?.orgId != DefaultOrg.OrgId" class="splash-wrapper">

            <h3>Connecting to a Onelynk Specialist</h3>

            <div class="spinner"></div>

          </div>
        </div>


        <button *ngIf="user?.info?.orgId != DefaultOrg.OrgId" style="float:right" type="button" class="button-action" pButton (click)="onEndChat()" label="End Chat"></button>

      </div>
    </section>

  </p-dialog>

</div>
